import type { User } from '@/@types/user'
import useUser from '@/utils/hooks/useUser'
import { isNil } from 'lodash-es'
import type { HTMLAttributes, ReactNode } from 'react'

export interface UserLoaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
	username: string
	children?: (user: User) => ReactNode
	placeholder?: ReactNode
}

export default function UserLoader({ username, children, placeholder, ...props }: UserLoaderProps) {
	const user = useUser(username)

	if (isNil(username)) {
		return null
	}

	if (isNil(user)) {
		return placeholder
	}

	return children?.(user)
}
